<template>
  <el-dialog
    append-to-body
    :title="$t('36')"
    :visible.sync="visible"
    v-if="visible"
    :close-on-click-modal="false"
    width="800px"
  >
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('bulkImport')" name="1">
        <upload type="add" />
      </el-tab-pane>
      <el-tab-pane :label="$t('batch_update')" name="2">
        <upload type="update" />
      </el-tab-pane>
    </el-tabs>

    <!-- 确认取消 -->
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="doSubmit">{{ $t('67') }}</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import upload from './upload.vue'
export default {
  data() {
    return {
      visible: false,
      activeName: '1'
    }
  },
  components: { upload },
  methods: {
    init() {
      this.visible = true
    }
    // doSubmit() {
    //   this.visible = false
    //   this.$emit('submit')
    // }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 10px 20px 30px 20px;
}

section {
  margin-bottom: 20px;
}
.upload-dialog-des {
  display: block;
  font-size: 12px;
  line-height: 30px;
  color: #ccc;
}
.upload-demo {
  margin-top: 15px;
  text-align: center;
}
</style>
